module.exports = __webpack_public_path__ + "static/rewards-card-banner-jd-7b9c6460a8f9d889cf516d0910caec62.png";